import { evaluateRouteRedirect } from '../utils';
import { authService } from '../../services';

const redirectIfMissingTags = ( routePath, tags ) => () => {
    const isAuthenticated = authService.isAuthenticated();
    if ( isAuthenticated ) {
        const requiredTags = Array.isArray( tags ) ? tags : [ tags ];
        const userTags = authService.getTags() || [];
        const hasEveryRequiredTag = requiredTags.every( ( tag ) => ( userTags.includes( tag ) ) );
        
        if ( !hasEveryRequiredTag ) {
            return evaluateRouteRedirect( routePath );
        }
    }
    else {
        // If the user is not authenticated, we don't know anything about their
        // tags, so don't do anything.
        return undefined;
    }
};

export default redirectIfMissingTags;
